import { render, staticRenderFns } from "./pubHeader.vue?vue&type=template&id=407f4ae8&scoped=true&"
import script from "./pubHeader.vue?vue&type=script&lang=js&"
export * from "./pubHeader.vue?vue&type=script&lang=js&"
import style0 from "./pubHeader.vue?vue&type=style&index=0&id=407f4ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407f4ae8",
  null
  
)

export default component.exports